import styled from 'styled-components';

import { ContactLink } from 'app/theme/ContactLink';
import { Grid, GridColumn } from 'app/theme/Grid';
import { breakpoint } from 'app/theme/theme';
import { contactData } from 'pkg/components/layout/contactData';

import { EmailIcon } from './EmailIcon';
import { PhoneIcon } from './PhoneIcon';

const Container = styled.footer`
  color: #464646;
  background-color: ${({ theme }) => theme.palette.white};
  padding: 2.5rem 1.6rem 2rem 1.6rem;
  min-height: 13rem;

  a {
    color: #464646;
  }

  ${breakpoint.up.md`
    padding: 5rem 12rem 2.2rem 12rem;
  `}

  ${breakpoint.up.lg`
    padding: 5rem 0 2.2rem 0;
    max-width: 1100px;
    margin: 0 auto;
  `}
`;

const Column = styled(GridColumn)`
  &&&&& {
    display: flex;
    flex-direction: column;
  }
`;

const CopyrightContainer = styled.div`
  flex-grow: 1;
  font-size: 1.3rem;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const HeaderText = styled.span`
  font-weight: 700;
  font-size: 1.8rem;
`;

const Text = styled.span`
  margin-top: 0.6rem;
  font-size: 1.4rem;
  text-align: center;

  ${breakpoint.up.md`
    flex-direction: row;
    padding: 0;
    text-align: start;
  `}
`;

const FooterRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-left: 1rem;
  padding-right: 1rem;
  margin-bottom: 1rem;

  ${breakpoint.up.md`
    flex-direction: row;
    padding: 0;
    margin-bottom: 4rem;
  `}
`;

const MoreComplexNeedsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  margin-bottom: 1rem;
  max-width: 723px;

  ${breakpoint.up.md`
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 0;
  `}
`;

const ContentCenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

const ContentRightWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;

  ${breakpoint.up.md`
    justify-content: flex-end;
    margin-bottom: 0;
  `}
`;

export const Footer = (): JSX.Element => (
  <Container>
    <FooterRow>
      <MoreComplexNeedsWrapper>
        <HeaderText>{contactData.moreComplexNeeds}</HeaderText>
        <Text>{contactData.moreComplexNeedsDescription}</Text>
      </MoreComplexNeedsWrapper>

      <ContentCenterWrapper>
        <PhoneIcon />

        <ContactLink aria-label="phone number" href={`tel:${contactData.phoneNumber}`}>
          <strong>{contactData.phoneNumber}</strong>
        </ContactLink>
      </ContentCenterWrapper>

      <ContentRightWrapper>
        <EmailIcon />

        <ContactLink aria-label="e-mail" href={`mailto:${contactData.email}`}>
          <strong>{contactData.email}</strong>
        </ContactLink>
      </ContentRightWrapper>
    </FooterRow>

    <Grid>
      <Column mobile={16}>
        <CopyrightContainer>
          <span>
            {contactData.copyright}
            <a target="_blank" rel="noreferrer" href={contactData.policy}>
              Privacy Policy
            </a>
          </span>
        </CopyrightContainer>
      </Column>
    </Grid>
  </Container>
);
